import { atom } from "recoil";

const macronutrientsAtom = atom({
  key: "macronutrients",
  default: {},
});

export default macronutrientsAtom;
